import themeData from "@digital-hig/theme-data/lib/build/json/lightTheme/nestedTheme.json";

const iris = themeData.nestedRoles.primitives.colors.accent.iris;
const plant = themeData.nestedRoles.primitives.colors.accent.plant;
const gold = themeData.nestedRoles.primitives.colors.accent.gold;
const lightSlate = themeData.nestedRoles.primitives.colors.detail["slate-light"];

export function DocsBadge({label}) {

  const textColor = (label === "New" ? "#fff" : "#000")
  const badgeColor = (
    label === "Beta" ? plant 
    : label === "New" ? iris 
    : label === "Deprecated" ? lightSlate 
    : label === "Internal" ? gold
    : null
    )

  if (!label) {
    throw new Error ("Missing badge label")
  }

  return (
    <div
    css={{
      fontWeight: 600,
      color: `${textColor}`,
      backgroundColor: `${badgeColor}`,
      borderRadius: 100,
      height: 16,
      width: "fit-content",
      padding: "5px 8px 5px 8px",
      marginLeft: 5,
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center"
    }}>{label}</div>
  )
}
